exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../../node_modules/css-loader/index.js!../../css/common.css"), "");

// module
exports.push([module.id, ".modal-abso{position:fixed;background-color:rgba(0,0,0,.05);margin:auto;top:0;left:0;right:0;bottom:0;z-index:2000;overflow-y:auto;background-color:rgba(0,0,0,.5)}.modal-content{width:700px;margin-top:30%;background-color:#393e46}.modal-title{color:#fff;text-align:left!important}.modal-footer,.modal-header{border-bottom:1px solid @border-color;border-top:1px solid @border-color}.item-title{text-align:left}table td{text-align:center}.bdt{border-top:1px solid #222831!important}.bdb{border-bottom:1px solid #222831;height:50px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/popups/BaseModel.vue
 ** module id = 78
 ** module chunks = 0
 **/